import React, { useState } from "react";
import AtomExplorer from "./AtomExplorer";
import AtomExplorerDual from "./AtomExplorerDual";
import ParticleSimulator from "./ParticleSimulator";
import WaveParticleDuality from "./WaveParticleDuality";
import QuantumTunnelingSimulator from "./QuantumTunnelingSimulator";

import "./QuantumPhysics.css";
import image1 from "../../assets/QP/1.png";
import image2 from "../../assets/QP/2.png";
import image3 from "../../assets/QP/3.png";
import image4 from "../../assets/QP/4.png";

export default function QuantumPhysics() {
  const [activeExp, setActiveExp] = useState(null);


  const experiments = [
    {
      id: "atom",
      name: "Atom Explorer",
      desc: "Visualize nucleus and electron orbitals in 3D.",
      img: image1,
      component: <AtomExplorerDual />,
      status: "active",

    },
    {
      id: "particle",
      name: "Particle Simulator",
      desc: "Simulate electrons, protons, quarks, and their interactions.",
      img: image2,

      component: <ParticleSimulator />,
      status: "active",

    },
    {
      id: "wave",
      name: "Double-Slit Experiment",
      desc: "Fire electrons/photons, and toggle which-path detectors.",
      img: image3,
      component: <WaveParticleDuality />,
      status: "active",

    },
    {
      id: "tunneling",
      name: "Quantum Tunneling",
      desc: "Visualize particle tunneling through potential barriers.",
      img: image4,
      component: <QuantumTunnelingSimulator />,
      status: "active"
    }
    
  ];

  const activeExperiment = experiments.find((exp) => exp.id === activeExp);

  if (activeExperiment) {
    return (
      <div className="qp-root">
        <button className="qp-back-btn" onClick={() => setActiveExp(null)}>
          ← Back to Quantum Physics Hub
        </button>
        {activeExperiment.component}
      </div>
    );
  }



  return (

    <>

    <div className="qr-root">
    <h2 className="qr-title">🧬 Quantum Physics</h2>
    <p className="qr-subtitle">
    Explore particles, atoms, wave-particle duality, and quantum properties.
    </p>

    <div className="qr-grid">
      {experiments.map((exp) => (
        <div
          key={exp.id}
          className={`qr-card ${exp.status}`}
          onClick={() =>
            exp.status === "active" ? setActiveExp(exp.id) : null
          }
        >
          <div
            className="qr-card-img"
            style={{ backgroundImage: `url(${exp.img})` }}
          ></div>

          <div className="qr-card-body">
            <h3>{exp.name}</h3>
            <p>{exp.desc}</p>
            {exp.status === "active" ? (
              <button className="qr-btn">Open Experiment</button>
            ) : (
              <button className="qr-btn disabled">Coming Soon</button>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>

    
  </>
  );

}
